export class EventModel {
  constructor(
    public id?: string,
    public name?: string,
    public description?: string,
    public title?: string,
    public startDateTime?: any,
    public startTime?: string,
    public endDateTime?: any,
    public rate?: number,
    public myRate?: number,
    public venueId?: string,
    public venueAddress?: string,
    public venueCity?: string,
    public venueCountryCode?: string,
    public pictureUrl?: string,
    public isReserved?: boolean,
    public status?: string,
    public numberOfReviews?: number,
    public confirmed?: number,
    public available?: number,
    public expected?: number,
    public pending?: number,
    public seated?: number,
    public lateGuest?: number,
    public maximumCapacity?: number
  ) { }
}

export class EventModelRequest {
  constructor(
    public Name?: string,
    public Title?: string,
    public Description?: string,
    public StartDateTime?: string,
    public StartTime?: string,
    public EndDateTime?: string,
    public VenueId?: string,
    public EventTypesIds?: string[],
    public MaxCapacity?: number,
    public PictureUrl?: string | ArrayBuffer
  ) { }
}
export class UpdateEventModelRequest {
  constructor(
    public Id?: string,
    public Name?: string,
    public Title?: string,
    public Description?: string,
    public StartDateTime?: string,
    public StartTime?: string,
    public EndDateTime?: string,
    public VenueId?: string,
    public EventTypesIds?: string[],
    public MaxCapacity?: number,
    public PictureUrl?: string | ArrayBuffer
  ) { }
}

export class EventDetailsModelResponse {
  public id: string;
  public name: string;
  public description: string;
  public title: string;
  public startDateTime: any;
  public startTime: string;
  public endDateTime: any;
  public rate: string;
  public myRate: string;
  public venueAddress: string;
  public venueCity: string;
  public venueCountryCode: string;
  public pictureUrl: string;
  public isReserved: boolean;
  public status: string;
  public numberOfReviews: number;
  public confirmed: number;
  public available: number;
  public expected: number;
  public pending: number;
  public seated: number;
  public lateGuest: number;
  public maximumCapacity: number;
  public venueEmail: string;
  public venueId: string;
  public venueLatitude: number;
  public venueLongitude: number;
  public venueName: string;
  public venuePhone: string;
  public venueRate: any;
  public venueWebsiteUrl: string;
  public eventTypeIds: number[];
}